import { render, staticRenderFns } from "./WhySkillUp.vue?vue&type=template&id=90bc59b6&scoped=true"
import script from "./WhySkillUp.vue?vue&type=script&lang=js"
export * from "./WhySkillUp.vue?vue&type=script&lang=js"
import style0 from "./WhySkillUp.vue?vue&type=style&index=0&id=90bc59b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc59b6",
  null
  
)

export default component.exports